module.exports = "/lucky-balls/img/icons/192.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/icons/192.png
// module id = 1061
// module chunks = 0